import { FaroChangeThumbnailDialog } from "@components/common/dialog/faro-change-thumbnail-dialog";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { selectedGroupSelector } from "@store/groups/groups-selector";
import { updateGroupDetails } from "@store/groups/groups-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { neutral, ImageEditIcon } from "@flat-ui";
import { ThumbnailSubjectType } from "@utils/thumbnail-utils";
import { ChangeGroupDetailsEvents } from "@utils/track-event/track-event-list";
import { useState } from "react";

export function ChangeGroupThumbnailButton(): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const selectedGroup = useAppSelector(selectedGroupSelector);
  const dispatch = useAppDispatch();

  return (
    <>
      <SphereTooltip title="Change thumbnail">
        <SphereIconButton
          component={ImageEditIcon}
          buttonSize="24"
          iconSize="24"
          color={neutral[800]}
          onClick={() => setIsDialogOpen(true)}
        />
      </SphereTooltip>

      {isDialogOpen && selectedGroup && (
        <FaroChangeThumbnailDialog
          setIsDialogOpen={setIsDialogOpen}
          subjectId={selectedGroup?.id}
          subjectType={ThumbnailSubjectType.group}
          existingThumbnailUrl={selectedGroup.thumbnailUrl}
          onUpdateThumbnail={async (thumbnailUrl: string) => {
            await dispatch(
              updateGroupDetails({
                groupId: selectedGroup.id,
                payload: { imageUrl: thumbnailUrl },
              })
            ).unwrap();
          }}
          eventName={ChangeGroupDetailsEvents.changeGroupThumbnail}
        />
      )}
    </>
  );
}
